function urlSearchParamsAsObject( searchParams: URLSearchParams ) {
    const obj: Record<string, string | Array<string>> = {};

    for ( const [ key, value ] of searchParams ) {
        const existing = key in obj;
        const existingMultiVal = Array.isArray( obj[ key ] );

        if ( existing && existingMultiVal ) {
            ( obj[ key ] as Array<string> ).push( value );
        } else if ( existing && !existingMultiVal ) {
            obj[ key ] = [
                obj[ key ] as string,
                value,
            ];
        } else {
            obj[ key ] = value;
        }
    }

    return obj;
}

export {
    urlSearchParamsAsObject,
};
